<div class="updox-attachments-panel">

  <!-- Initial load spinner (first fetch only) -->
  <div *ngIf="isLoading" class="text-center text-muted p-sm">
    <i class="fa fa-spinner fa-spin mr-sm"></i> Loading attachments...
  </div>

  <!-- Empty (no attachments at all, not loading) -->
  <div *ngIf="!isLoading && totalCount === 0" class="text-muted p-sm">
    <i class="fa fa-paperclip mr-sm"></i> No attachments.
  </div>

  <!-- Pending processing — normal state (job still running, within timeout) -->
  <div class="updox-attachment-pending" *ngIf="pending.length > 0 && !pollTimedOut">
    <i class="fa fa-spinner fa-spin mr-sm text-warning"></i>
    <strong>Processing {{ pending.length }} attachment(s)…</strong>
    <ul class="updox-pending-list">
      <li *ngFor="let p of pending">
        <div class="updox-attachment-pending-row">
          <span>
            <i class="fa fa-file-o mr-sm text-muted"></i>{{ p.file_name }}
            <span class="label label-info ml-sm" *ngIf="p.is_ccda">C-CDA</span>
          </span>
          <!-- Pending C-CDA can still be parsed from raw metadata -->
          <a class="btn btn-xs btn-info btn-outline ml-sm"
             *ngIf="p.is_ccda"
             (click)="openCcdaPreviewForPending(p)"
             [class.active]="activeCcdaPendingIndex === p.index"
             title="Preview clinical data while processing">
            <i class="fa fa-file-text-o mr-sm"></i>Clinical Summary
          </a>
        </div>
      </li>
    </ul>
  </div>

  <!-- Timed out — job never finished after 48 s -->
  <div class="updox-attachment-timeout" *ngIf="pollTimedOut && pending.length > 0">
    <i class="fa fa-exclamation-triangle mr-sm text-warning"></i>
    <span>Attachments are still being processed by the server.</span>
    <a class="btn btn-xs btn-default btn-outline ml-sm" (click)="retryPolling()">
      <i class="fa fa-refresh mr-sm"></i>Check Again
    </a>
    <ul class="updox-pending-list mt-sm">
      <li *ngFor="let p of pending">
        <div class="updox-attachment-pending-row">
          <span>
            <i class="fa fa-file-o mr-sm text-muted"></i>{{ p.file_name }}
            <span class="label label-info ml-sm" *ngIf="p.is_ccda">C-CDA</span>
          </span>
          <a class="btn btn-xs btn-info btn-outline ml-sm"
             *ngIf="p.is_ccda"
             (click)="openCcdaPreviewForPending(p)"
             [class.active]="activeCcdaPendingIndex === p.index">
            <i class="fa fa-file-text-o mr-sm"></i>Clinical Summary
          </a>
        </div>
      </li>
    </ul>
  </div>

  <!-- Processed attachment rows -->
  <div class="updox-attachment-item" *ngFor="let att of attachments">

    <!-- Row -->
    <div class="updox-attachment-row">
      <div class="updox-attachment-info">
        <i class="fa {{ fileIcon(att.document_content_type) }} fs15 mr-sm"></i>
        <span class="fw-500 fs13">{{ att.document_file_name }}</span>
<!--        <span class="label label-primary ml-sm ccda-label" *ngIf="att.is_ccda">-->
<!--          <i class="fa fa-file-text-o mr-sm"></i>C-CDA Clinical Summary-->
<!--        </span>-->
      </div>
      <div class="updox-attachment-actions">
        <a class="btn btn-xs btn-default btn-outline mr-sm" (click)="viewDocument(att)" title="Open in new tab">
          <i class="fa fa-external-link mr-sm"></i>View
        </a>

        <a class="btn btn-xs btn-secondary btn-outline mr-sm summary-btn "


           *ngIf="att.is_ccda && !readOnly"
           (click)="activeCcdaAttachment?.id === att.id ? closeCcdaPreview() : openCcdaPreview(att)"
           [class.active]="activeCcdaAttachment?.id === att.id"
           title="View structured clinical data">
          <i class="fa fa-file-text-o mr-sm"></i>Clinical Summary
        </a>
        <a class="btn btn-xs btn-success btn-outline"
           *ngIf="!readOnly"
           (click)="activeAddToChartId === att.id ? closeAddToChart() : openAddToChart(att)"
           [class.active]="activeAddToChartId === att.id"
           title="Add this document to patient chart">
          <i class="fa fa-plus-circle mr-sm"></i>Add to Chart
        </a>
      </div>
    </div>

    <!-- Inline Add-to-Chart form -->
    <div class="updox-add-to-chart-form" *ngIf="!readOnly && activeAddToChartId === att.id">

      <!-- Step 1: Patient selection -->
      <div class="updox-atc-section-label">
        <i class="fa fa-user mr-sm text-info"></i>
        <span class="fw-500">Patient</span>
        <span class="text-danger ml-sm">*</span>
      </div>

      <!-- Auto-detect loading state -->
      <div class="updox-patient-autodetect-loading" *ngIf="!selectedPatient && patientSearchLoading && !patientQuery">
        <i class="fa fa-spinner fa-spin mr-sm text-info"></i>
        <span class="fs12 text-muted">Looking up linked patient…</span>
      </div>

      <!-- Selected patient confirmation card (same layout for auto-detect and manual select) -->
      <div class="updox-patient-selected-card" *ngIf="selectedPatient">
        <div class="updox-patient-card-header">
          <span class="updox-avatar bg-secondary updox-avatar-sm updox-avatar-color-{{ patientInitial | lowercase }}">
            {{ patientInitial }}
          </span>
          <div class="updox-patient-card-body">
            <div class="updox-patient-card-name">
              {{ selectedPatient.name }}
              <span class="updox-badge-autodetect" *ngIf="patientAutoDetected">
                <i class="fa fa-link mr-sm"></i>Linked to message
              </span>
            </div>
            <div class="updox-patient-card-meta" *ngIf="patientDemographics(selectedPatient) as demo">
              <span class="updox-patient-meta-chip">
                <i class="fa fa-id-card-o mr-sm"></i>{{ demo }}
              </span>
            </div>
            <div class="updox-patient-card-meta" *ngIf="patientPhone(selectedPatient) as phone">
              <span class="updox-patient-meta-chip">
                <i class="fa fa-phone mr-sm"></i>{{ phone }}
              </span>
            </div>
          </div>
        </div>
        <div class="updox-patient-card-footer">
          <span class="text-success fs11">
            <i class="fa fa-check-circle mr-sm"></i>Patient confirmed
          </span>
          <button type="button" class="btn btn-xs btn-default btn-outline"
                  (click)="clearPatient()">
            <i class="fa fa-pencil mr-sm"></i>Change Patient
          </button>
        </div>
      </div>

      <!-- Patient search input (shown when no patient selected, and not auto-loading) -->
      <div class="updox-patient-search-wrap p" *ngIf="!selectedPatient && !(patientSearchLoading && !patientQuery)">
        <div class="updox-patient-search-field">
          <i class="fa fa-search updox-patient-search-icon text-muted"></i>
          <input type="text" class="form-control input-sm updox-patient-search-input"
                 [(ngModel)]="patientQuery"
                 (ngModelChange)="onPatientQueryChange($event)"
                 (blur)="closePatientDropdownDelayed()"
                 placeholder="Search by name, phone or email…"
                 autocomplete="off" />
          <i class="fa fa-spinner fa-spin updox-patient-search-spinner text-primary"
             *ngIf="patientSearchLoading"></i>
        </div>
        <p class="help-block fs12 m0 mt-sm" *ngIf="!patientQuery">
          <i class="fa fa-info-circle mr-sm text-info"></i>
          Type at least 2 characters to search for a patient
        </p>
        <p class="help-block text-muted fs11 m0 mt-sm"
           *ngIf="patientQuery && !patientSearchLoading && patientResults.length === 0 && !showPatientDropdown">
          <i class="fa fa-exclamation-circle mr-sm"></i>No patients found for "{{ patientQuery }}"
        </p>

        <!-- Search results dropdown -->
        <div class="updox-patient-dropdown" *ngIf="showPatientDropdown">
          <div class="updox-patient-option" *ngFor="let p of patientResults"
               (mousedown)="selectPatient(p)">
            <span class="updox-avatar updox-avatar-xs">{{ patientInitialFor(p) }}</span>
            <div class="updox-patient-option-info">
              <div class="fw-500 fs13">{{ p.name }}</div>
              <div class="updox-patient-option-meta" *ngIf="patientDemographics(p) as demo">
                <i class="fa fa-id-card-o mr-sm text-muted"></i>{{ demo }}
              </div>
              <div class="updox-patient-option-meta" *ngIf="patientPhone(p) as phone">
                <i class="fa fa-phone mr-sm text-muted"></i>{{ phone }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Step 2: Document details (revealed after patient selected) -->
      <div class="updox-atc-details" [class.updox-atc-details-muted]="!selectedPatient">
        <div class="updox-atc-section-label mt-xl mb-lg">
          <i class="fa fa-file-text mr-sm text-info"></i>
          <span class="fw-500">Document Details</span>
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-12 col-sm-12 form-group mb-sm">
            <label class="field-label">Document Name</label>
            <input type="text" class="form-control input-sm" [(ngModel)]="addToChartName"
                   [disabled]="!selectedPatient"
                   placeholder="Defaults to message subject if left blank" />
          </div>
          <div class="col-lg-3 col-md-6 col-sm-12 form-group mb-sm">
            <label class="field-label">Document Type</label>
            <select class="form-control input-sm" [(ngModel)]="addToChartDocTypeId"
                    [disabled]="!selectedPatient">
              <option [ngValue]="null">Select Type</option>
              <option *ngFor="let dt of documentTypes" [ngValue]="dt.id">{{ dt.name }}</option>
            </select>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-12 form-group mb-sm">
            <label class="field-label">Document Date</label>
            <input type="date" class="form-control input-sm" [(ngModel)]="addToChartDate"
                   [disabled]="!selectedPatient" />
          </div>
        </div>
      </div>

      <!-- Actions -->
      <div class="updox-atc-footer">
        <button type="button" class="btn btn-sm btn-default mr-sm" (click)="closeAddToChart()">
          Cancel
        </button>
        <button type="button" class="btn btn-sm btn-success"
                (click)="submitAddToChart()"
                [disabled]="isAddingToChart || !addToChartPatientId"
                [title]="!addToChartPatientId ? 'Select a patient first' : ''">
          <i class="fa fa-spinner fa-spin mr-sm" *ngIf="isAddingToChart"></i>
          <i class="fa fa-check mr-sm" *ngIf="!isAddingToChart"></i>
          {{ isAddingToChart ? 'Saving to Chart…' : 'Save to Chart' }}
        </button>
      </div>
    </div>
  </div>
  <!-- C-CDA Preview panel — processed attachment -->
  <!-- The following code need to be uncomment +HSA+ -->
  <app-updox-ccda-preview
    *ngIf="activeCcdaAttachment"
    [message]="message"
    [attachment]="activeCcdaAttachment"
    (close)="closeCcdaPreview()"
    (chartAdded)="onChartAdded()">
  </app-updox-ccda-preview>

  <!-- C-CDA Preview panel — pending attachment (parsed from raw metadata) -->
  <app-updox-ccda-preview
    *ngIf="activeCcdaPendingIndex != null"
    [message]="message"
    [metadataIndex]="activeCcdaPendingIndex"
    (close)="closeCcdaPreview()"
    (chartAdded)="onChartAdded()">
  </app-updox-ccda-preview>

</div>
